/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable max-len */
/* eslint-disable react/prop-types */
/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import cx from 'classnames';
import { Link, useNavigate } from 'react-router-dom';
import Player from '@vimeo/player';
// import CircularProgressWithLabel from './CircularProgress';
import LinearProgress from '@mui/material/LinearProgress';
import { useAuthContext } from '../../hooks/useAuthContext';
import useProductsContext from '../../hooks/useProductsContext';

import classes from './index.module.css';
import useConnectionContext from '../../hooks/useConnectionContext';
import useApplicationContext from '../../hooks/useApplicationContext';

const Card = ({
  name, label, notes, enableLink, learnMoreLink, media, mediaPoster,
}) => {
  const playerRef = React.useRef();
  const posterRef = React.createRef();
  const [loaded, setLoaded] = React.useState(false);
  const [progress, setProgress] = React.useState(0);
  const navigate = useNavigate();
  const { productsGallery, galleryLoading } = useProductsContext();
  const { store, isLoading } = useConnectionContext();
  const { info } = store || {};

  const clickHandler = () => {
    if (isLoading || galleryLoading) {
      console.log('pending');
    } else {
      const domain = window.location.href.indexOf('admin.seel.com') > -1 ? 'ra.kover.ai' : 'test-ra.kover.ai';
      let installationLink = null;
      productsGallery.forEach((item) => {
        if (item.inssuranceName === name && !item.authorized) {
          installationLink = `https://${domain}/auth?shop=${info}`;
        }
      });
      console.log(installationLink);
      navigate(installationLink || enableLink);
    }
  };

  React.useEffect(() => {
    playerRef.current = new Player(`player${media}`, {
      id: media,
      width: 480,
      height: 270,
    });
    playerRef.current.on('progress', (data) => {
      const { percent } = data;
      const value = Math.parseInt(percent * 100);
      console.log('loading progress', ...data);
      setProgress(value);
    });
    playerRef.current.on('loaded', (data) => {
      setProgress(100);
      setLoaded(true);
      console.log('media loaded');
    });
  }, []);

  // https://stackoverflow.com/questions/52303820/react-ontransitionend-event-gets-called-frequently
  const handleTransitionEnd = () => {
    posterRef.current.remove();
  };

  return (
    <div className={classes.card}>
      <div className={classes.card_media} id={`player${media}`}>
        <img ref={posterRef} onTransitionEnd={handleTransitionEnd} src={mediaPoster} alt="" className={cx({ [classes.card_media_poster]: true, [classes.card_media_poster_hide]: loaded })} />
        {/* {
          !loaded ? <CircularProgressWithLabel value={progress} /> : null
        } */}
        {/* {
          !loaded ? <LinearProgress sx={{ position: 'absolute', bottom: 0, width: '100%' }} color="inherit" /> : null
        } */}
        <LinearProgress sx={{ position: 'absolute', top: 0, width: '100%' }} color="inherit" variant="determinate" value={progress} />
      </div>
      <div className={classes.card_content}>
        <div className={classes.card_name}>{name}</div>
        <div className={classes.card_label}>{label}</div>
        <div className={classes.card_notes}>
          {
            notes.map((item) => (<li key={item} className={classes.card_notes_item}>{item}</li>))
          }
        </div>
        <div className={classes.card_bottom}>
          <div onClick={clickHandler} className={cx({ [classes.card_button]: true, [classes.card_button_filled]: true, [classes.card_button_disable]: isLoading || galleryLoading })}>Enable &gt;</div>
          {learnMoreLink ? <Link to={learnMoreLink}><div className={classes.card_button}>Learn more &gt;</div></Link> : null}
        </div>
      </div>
    </div>
  );
};

function OnboardingSelect() {
  const { merchantName = '' } = useAuthContext();
  const { data: { EDD }, isLoading } = useApplicationContext();
  const selection = [{
    name: 'Estimated Delivery Date',
    label: 'For all merchants',
    notes: ['The most accurate delivery date estimate (better than USPS/UPS/Fedex)',
      'Increase conversion rate on gifts & other time sensitive purchases',
      'Turn late deliveries into repeat customers with guaranteed delivery date'],
    enableLink: `/edd/application/${EDD && EDD.canUpgrade ? 'data-checking' : 'processing-time'}`,
    learnMoreLink: '',
    media: '766828050',
    mediaPoster: 'http://i.vimeocdn.com/video/1539674593-84a303cfef8078a036742e4eaa4bd2608312d333101a9f5683e100f87921602d-d_640',
  }, {
    name: 'Return Assurance',
    label: 'For merchants with final sale items',
    notes: ['Offer "return-to-Seel" option on your final sale products',
      'Encourage more purchases by giving shoppers peace of mind',
      'Earn 6% net new revenue from increased conversion rate'],
    enableLink: 'https://ntcchgwtg0g.typeform.com/to/EdBu9IDK',
    learnMoreLink: 'https://www.seel.com/ra',
    media: '767154771',
    mediaPoster: 'http://i.vimeocdn.com/video/1540268046-6fefcef6f73e569596efb683efe34a7d65374a53436aa46ac508e3b4a2a222fc-d_640',
  }];
  return (
    <div>
      <div className={classes.header}>
        <div className={classes.greeting}>{`Welcome ${merchantName}!`}</div>
        <div className={classes.greeting}>
          Start adding features that give shoppers peace of mind.
        </div>
        <div className={classes.guide}>
          Click &#34;Enable&#34; to start adding features that are right for your business.
        </div>
      </div>
      <div className={classes.selection_section}>
        {
          selection.map((item) => (<Card key={item.name} {...item} />))
        }
      </div>
    </div>
  );
}

export default OnboardingSelect;
